import { LoginComponent } from './login/login.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from '../shared/components/not-found/not-found.component';
import { MainComponent } from './main/main.component';
import { InicioComponent } from './inicio/inicio.component';

const mainRoutes: Routes = [
  {
    path: 'main',
    component: MainComponent,
    children: [
      { path: '', component: LoginComponent  },
      { path: 'login', component: LoginComponent },
      { path: 'inicio', component: InicioComponent },
      { path: '**', component: NotFoundComponent }
    ] 
  }  
];

@NgModule({
  imports: [RouterModule.forChild(mainRoutes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }
